import AddressConfirmationWrapperScreen from 'features/personalInfo/confirmYourAddress/screens/AddressConfirmationWrapperScreen/AddressConfirmationWrapperScreen';
import React from 'react';

export default function ConfirmAddress() {
  return <AddressConfirmationWrapperScreen />;
}
